<template>
  <div class="home-wrap">
    <div class="padding-11-15 padding-b-0">
      <div class="title-text-official padding-b-19">佣金明细</div>
      <div class="search-wrap">
        <div class="search-form">
          <div class="search-item search-input-item">
            <Select v-model="searchForm.type" placeholder="事件类型">
              <Option v-for="item in type_list" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </div>
          <div class="search-item search-input-item search-box date-picker">
            <el-col :span="11">
              <el-input v-model="searchForm.createStartTime" @blur.native @focus="showDatePicker('createStartTime')" placeholder="选择日期" suffix-icon="el-icon-times" readonly></el-input>
              <img class="clear-icon" v-show="searchForm.createStartTime" src="../../../../assets/img/login_btn_cancel.png" alt="" @click="clear('searchForm.createStartTime')">
            </el-col>
            <el-col :span="2" class="date-range">至</el-col>
            <el-col :span="11">
              <el-input v-model="searchForm.createEndTime" @blur.native @focus="showDatePicker('createEndTime')" placeholder="选择日期" suffix-icon="el-icon-times" readonly></el-input>
              <img class="clear-icon" v-show="searchForm.createEndTime" src="../../../../assets/img/login_btn_cancel.png" alt="" @click="clear('searchForm.createEndTime')">
            </el-col>
          </div>
        </div>
        <div class="search-btn" @click="handleFilter">查询</div>
      </div>
    </div>
    <div class="gray"></div>
    <div class="padding-0-15 padding-b-8">
      <div class="title-text-official padding-11-0 padding-b-19">列表</div>
      <div class="table-wrapper">
        <el-table :data="list" border style="width: 100%">
          <el-table-column prop="date" label="明细时间" width="90" align="center">
            <template slot-scope="{row}">
              <span>{{ row.createTimeStr }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="事件类型" width="80" align="center">
            <template slot-scope="{ row }">
              <span>{{nowIncomeText(row.type)}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="明细说明" width="150" align="center">
            <template slot-scope="{row}">
              <span>{{ row.orderUUID }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="变动金额(元)" width="100" align="center">
            <template slot-scope="{row}">
              <span>{{ row.amountDollar }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="变动后金额(元)" width="100" align="center">
            <template slot-scope="{row}">
              <span>{{ row.afterAmountDollar }}</span>
            </template>
          </el-table-column>
        </el-table>
        <pagination v-show="total>0" :total="total" :page.sync="searchForm.pageNo" :limit.sync="searchForm.pageSize" @pagination="getList(false)" />
      </div>
    </div>
    <DatePicker ref="DatePicker" :title="curDateTitle" @selectedDate="selectedDate"></DatePicker>
  </div>
</template>

<script>
import { getPlatformUuid } from '@/utils/auth'
import {  Select, Option} from 'view-design'
import DatePicker from '@/components/h5/DatePicker'
import Pagination from '@/components/h5/Pagination' // secondary package based on el-pagination
import mingxi from '@/javaApi/mingxi.js'
import { getDate } from '@/utils/date'
const mingxiModel = new mingxi()
export default {
  name: 'Mingxi',
  components: {
    DatePicker,
    Select,
    Option,
    Pagination
  },
  data: function () {
    return {
      listLoading: false,
      type_list:[
        {
          value: '',
          label: '全部'
        },
        {
          value: '1',
          label: '订单结算'
        },
        {
          value: '2',
          label: '余额结算'
        },
        {
          value: '3',
          label: '父平台奖励金'
        },
        {
          value: '4',
          label: '订单关闭'
        },
        {
          value: '5',
          label: '官方补贴'
        },
      ],
      list:[],
      total:0,
      searchForm: {
        pageNo: 1,
        pageSize: 10,
        type: undefined,
        createStartTime: undefined,
        createEndTime: undefined,
        platformUUID: getPlatformUuid()
      },
      incomeTableList:{
        1: '订单结算',
        2: '余额结算',
        3: '父平台奖励',
        4: '订单关闭',
        5: '官方补贴',
        11: '购票浮动折扣佣金结算',
      },
      curDateTitle: '',// 日期选择器弹窗标题
      datePicker: '', // 用于判断哪个选择器
    }
  },
  computed:{
  },
  created() {
    this.getList(true)
  },
  beforeDestroy(){
  },
  methods: {
    getList(first = false){
      this.listLoading = true
      if(first) this.searchForm.pageNo = 1
      let searchForm = Object.assign({}, this.searchForm)
      searchForm.createStartTime = getDate(searchForm.createStartTime)
      searchForm.createEndTime = getDate(searchForm.createEndTime)
      searchForm = this.formateInit(searchForm)
      if(searchForm.createStartTime){
        searchForm.createStartTime = searchForm.createStartTime+' 00:00:00'
      }
      if(searchForm.createEndTime){
        searchForm.createEndTime = searchForm.createEndTime+' 23:59:59'
      }
      let that = this
      mingxiModel.getPronfitMingxList(searchForm).then(response=>{
        that.listLoading = false
        let res = response.data
        if (res.code === 200) {
          that.list = res.data.list
          that.total = res.data.total
        } else {
          let message = res.message?res.message:'系统繁忙，请稍后再试！'
          that.$Message.error(message)
        }
      }).catch(error=>{
        that.listLoading = false
        if(error != 'token invalid'){
          that.$message.error('系统繁忙，请稍后再试！')
        }
      })
    },
    nowIncomeText:function (index) {
      return this.incomeTableList[index]?this.incomeTableList[index]:'暂无类型'
    },
    handleFilter(){
      console.log(this.searchForm)
      this.getList(true)
    },
    changePage(value){
      this.searchForm.pageNo = value
      this.getList()
    },
    changePagesize(value){
      this.searchForm.pageSize = value;
      //如果处于第一页改变数量，则会触发changePage
      if(this.searchForm.pageNo == 1){
        this.getList()
      }
    },
    show (index) {
      this.$refs.detail.init()
    },
    detail: function () {
      this.$refs.detail.init()
    },
    formateInit(formData){
      let objCopy = {};
      for(let key in formData){
        if(formData[key]){
          objCopy[key] = formData[key];
        }
      }
      return objCopy;
    },
    showDatePicker(datePicker){
      let title = '请选择开始日期';
      if(datePicker.toUpperCase().indexOf('END') > -1){
        title = '请选择结束日期';
      }
      this.curDateTitle = title
      this.datePicker = datePicker
      this.$refs.DatePicker.init();
    },
    selectedDate(timer){
      this.searchForm[this.datePicker] = timer;
    },
    //清除文本框
    clear(val) {
      if(val.indexOf(".") > -1){
        let varArr = val.split(".")
        this[varArr[0]][varArr[1]] = ''
      }else{
        this[val] = ''
      }
    },
  }
}
</script>
<style lang="less" scoped>
.home-wrap{
  font-family: Alibaba-PuHuiTi-R;
  .table-wrapper {
    width: 100%;
    .color-ff4{
      white-space: nowrap;
      line-height: 1.5;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/h5/official/mingxi/Index.vue